<script>
  import fornecedorServico from '../servico';
  import Carregando from '~componentes/Carregando.vue';
  import Paginacao from '~componentes/Paginacao.vue';
  import DatePicker from 'vue2-datepicker';
  import ModalArquivosContrato from '~componentes/ModalArquivosContrato.vue';

  export default {
    components: { Carregando, Paginacao, DatePicker, ModalArquivosContrato },
    data() {
      return {
        pagina: 1,
        totalRegistros: 0,
        totalPaginas: 0,
        registrosPorPagina: 0,
        contratos: [],
        contratoSelecionado: null,
        carregando: true,
        filtros: this.camposFiltros(),
        animated: true,
        configuracao: this.$storage.configuracao(),
        modalArquivos: false,
      }
    },
    methods: {
      camposFiltros() {
        return {
          periodo: '',
        };
      },
      limparFiltros() {
        this.filtros = this.camposFiltros();
        this.$nextTick(() => {});

        this.lista();
      },
      lista(pagina = 1) {
        this.carregando = true;

        return fornecedorServico.listaContrato(pagina, this.filtros)
          .then(res => {
            this.carregando = false;

            this.contratos = res.body.registros;
            this.totalRegistros = res.body.totalRegistros;
            this.totalPaginas = res.body.totalPaginas;
            this.registrosPorPagina = res.body.registrosPorPagina;
          });
      },
      mostrarEsconderFiltro(e) {
        if (!$(e.target).hasClass('fa-chevron-down') && !$(e.target).hasClass('fa-chevron-up')) {
          $('.collapse-link').trigger('click');
        }
      },
      mostrarModalArquivos(contrato) {
        this.contratoSelecionado = contrato;
        this.modalArquivos = true;
      },
      fecharModalArquivos() {
        this.animated = false;
        this.modalArquivos = false;
        this.contratoSelecionado = null;
      },
    },
    created() {
      this.lista(this.pagina);
    },
    mounted() {
      this.$root.tituloDaPagina = 'Contratos do Fornecedor';

      this.$root.botaoRetrocederMostrar = false;
      this.$root.botaoRetrocederRota = '';

      const _this = this;
    },
    watch: {
      '$route': 'lista'
    },
  }
</script>

<template>
  <div :class="['wrapper wrapper-content ', {'animated': animated}, $root.animacaoPadrao]">

    <modal-arquivos-contrato 
      :mostrar="modalArquivos"
      :id="contratoSelecionado ? contratoSelecionado.idContrato : ''"
      @fechado="fecharModalArquivos">
    </modal-arquivos-contrato>

    <div class="row">
      <div class="col-lg-12">
        <div class="ibox collapsed float-e-margins">

          <div class="ibox-title pointer" @click="mostrarEsconderFiltro">
            <h5>Filtrar lista <small class="m-l-sm">Clique para mostrar ou esconder os filtros</small></h5>

            <div class="ibox-tools">
              <span class="collapse-link">
                <i class="fa fa-chevron-up"></i>
              </span>
            </div>
          </div>

          <div class="ibox-content">

            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                  <label class="control-label">Período</label>

                  <date-picker v-model="filtros.periodo"
                               input-class="form-control"
                               range
                               :editable="false"
                               lang="pt-br"
                               :confirm="true"
                               range-separator="a"
                               format="DD/MM/YYYY"
                               :shortcuts="false">
                  </date-picker>

                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12">
                <div class="form-group no-margins">
                  <button type="button" class="btn btn-primary no-margins" @click="lista">
                    <i class="fa fa-search"></i>
                    Filtrar
                  </button>
                  <button type="button" class="btn btn-default no-margins" @click="limparFiltros">
                    <i class="fa fa-eraser"></i>
                    Limpar filtros
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="ibox-footer">

            <div class="table-responsive">
              <table class="table table-bordered table-column-code table-column-action">
                <thead>
                  <tr>
                    <th>Número</th>
                    <th>Nome Contrato</th>
                    <th>Valor(R$)</th>
                    <th>Data Assinatura</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(contrato, index) in contratos">
                    <td class="text-center">{{ contrato.idContrato || '---' }}</td>
                    <td>{{ contrato.nomeContrato || '---' }}</td>
                    <td>{{ contrato.valor | formatarNumero }}</td>
                    <td>{{ contrato.dataAssinatura | formatarData }}</td>
                    <td>
                      <button type="button"
                              class="btn btn-info btn-xs"
                              v-tooltip="'Listar ou adicionar arquivos do contrato'"
                              @click="mostrarModalArquivos(contrato)">
                        <i class="fa fa-archive"></i>
                      </button>
                    </td>
                  </tr>
                  <tr v-show="carregando">
                    <td colspan="8">
                      <i class='fa fa-spinner fa-pulse'></i> Carregando...
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <paginacao :page-count="totalPaginas"
                       :click-handler="lista"
                       :per-page="registrosPorPagina"
                       :register-count="totalRegistros"
                       :show-counter="true">
            </paginacao>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/fornecedor/componentes/ContratoLista.vue